import { ballArr, count, singleDouble, smallBig, dragonTiger } from '../resPatterns.js';

const ssc = (data, ranks, roads, type) => {
  let smallBigLabels = [];
  let singleDoubleLabels = [];
  if (type == 'ssc') {
    smallBigLabels = [{ name: '大', key: 1 }, { name: '小', key: 0 }];
    singleDoubleLabels = [{ name: '双', key: 1 }, { name: '单', key: 0 }];
  } else {
    smallBigLabels = [{ name: '大', key: 1 }, { name: '小', key: 0 }, { name: '和', key: 2 }];
    singleDoubleLabels = [{ name: '双', key: 1 }, { name: '单', key: 0 }, { name: '和', key: 2 }];
  }

  const longhuLabels = [{ name: '龙', key: 0 }, { name: '虎', key: 1 }];

  if (data.length == 0) {
    return [];
  }

  return data.reduce((a, b) => {
    let arr = ballArr(b.resultStr);
    let rescount = count(arr);
    if (type == 'choose5') {
      if (!a['tailCount']) {
        a['tailCount'] = {
          smallBig: { arrs: [], last: '', name: '大小', labels: [{ name: '大', key: 1 }, { name: '小', key: 0 }] }
        };
      }
      let tailCountSmallBig = rescount.toString().slice(-1) < 5 ? 0 : 1;
      if (a['tailCount'].smallBig.last === tailCountSmallBig) {
        let sblen = a['tailCount'].smallBig.arrs.length;
        a['tailCount'].smallBig.arrs[sblen - 1].push(tailCountSmallBig);
      } else {
        a['tailCount'].smallBig.last = tailCountSmallBig;
        a['tailCount'].smallBig.arrs.push([tailCountSmallBig]);
      }
    }

    if (!a['count']) {
      a['count'] = {
        smallBig: { arrs: [], last: '', name: '大小', labels: smallBigLabels },
        singleDouble: { arrs: [], last: '', name: '单双', labels: singleDoubleLabels }
      };
    }
    let countSingleDouble = '';
    let countSmallBig = '';
    //时时彩无和
    if (type == 'ssc') {
      countSmallBig = rescount < 23 ? 0 : 1;
      countSingleDouble = singleDouble(rescount);
    } else {
      //小于30为小 等于30和， 大于30为大
      countSmallBig = rescount == 30 ? 2 : rescount < 30 ? 0 : 1;
      countSingleDouble = rescount == 30 ? 2 : singleDouble(rescount);
    }
    if (a['count'].singleDouble.last === countSingleDouble) {
      let sdlen = a['count'].singleDouble.arrs.length;
      a['count'].singleDouble.arrs[sdlen - 1].push(countSingleDouble);
    } else {
      a['count'].singleDouble.last = countSingleDouble;
      a['count'].singleDouble.arrs.push([countSingleDouble]);
    }

    if (a['count'].smallBig.last === countSmallBig) {
      let sblen = a['count'].smallBig.arrs.length;
      a['count'].smallBig.arrs[sblen - 1].push(countSmallBig);
    } else {
      a['count'].smallBig.last = countSmallBig;
      a['count'].smallBig.arrs.push([countSmallBig]);
    }

    arr.map((x, i) => {
      if (!a[i]) {
        if (i == 0) {
          a[i] = {
            smallBig: { arrs: [], last: '', name: '大小', labels: smallBigLabels },
            singleDouble: { arrs: [], last: '', name: '单双', labels: singleDoubleLabels },
            dragonTiger: { arrs: [], last: '', name: '龙虎', labels: longhuLabels }
          };
        } else {
          a[i] = {
            smallBig: { arrs: [], last: '', name: '大小', labels: smallBigLabels },
            singleDouble: { arrs: [], last: '', name: '单双', labels: singleDoubleLabels }
          };
        }
      }

      let isingleDouble = x == 11 ? 2 : singleDouble(x);
      let ismallBig = x == 11 ? 2 : x < 5 ? 0 : 1;

      if (a[i].singleDouble.last === isingleDouble) {
        let sdlen = a[i].singleDouble.arrs.length;
        a[i].singleDouble.arrs[sdlen - 1].push(isingleDouble);
      } else {
        a[i].singleDouble.last = isingleDouble;
        a[i].singleDouble.arrs.push([isingleDouble]);
      }

      if (a[i].smallBig.last === ismallBig) {
        let sblen = a[i].smallBig.arrs.length;
        a[i].smallBig.arrs[sblen - 1].push(ismallBig);
      } else {
        a[i].smallBig.last = ismallBig;
        a[i].smallBig.arrs.push([ismallBig]);
      }
      if (i == 0) {
        //龙虎没有合
        let isLongHu = dragonTiger(arr[0], arr[arr.length - 1]) == 2 ? 2 : dragonTiger(arr[0], arr[arr.length - 1]);
        if (isLongHu != 2) {
          // 龙虎
          if (a[0].dragonTiger.last === isLongHu) {
            let sblen = a[0].dragonTiger.arrs.length;
            a[0].dragonTiger.arrs[sblen - 1].push(isLongHu);
          } else {
            a[0].dragonTiger.last = isLongHu;
            a[0].dragonTiger.arrs.push([isLongHu]);
          }
        }
      }
    });
    return a;
  }, {});
};
const pk10 = (data, ranks, roads) => {
  const smallBigLabels = [{ name: '大', key: 1 }, { name: '小', key: 0 }];
  const singleDoubleLabels = [{ name: '双', key: 1 }, { name: '单', key: 0 }];
  const dragonTigerLabels = [{ name: '龙', key: 0 }, { name: '虎', key: 1 }];
  if (data.length == 0) {
    return [];
  }

  return data.reduce((a, b) => {
    let arr = ballArr(b.resultStr);
    let gyh = count([arr[0], arr[1]]);

    if (!a['gyh']) {
      a['gyh'] = {
        smallBig: { arrs: [], last: '', name: '大小', labels: smallBigLabels },
        singleDouble: { arrs: [], last: '', name: '单双', labels: singleDoubleLabels }
      };
    }
    let gyhSingleDouble = singleDouble(gyh);
    let gyhSmallBig = gyh <= 11 ? 0 : 1;

    if (a['gyh'].singleDouble.last === gyhSingleDouble) {
      let sdlen = a['gyh'].singleDouble.arrs.length;
      a['gyh'].singleDouble.arrs[sdlen - 1].push(gyhSingleDouble);
    } else {
      a['gyh'].singleDouble.last = gyhSingleDouble;
      a['gyh'].singleDouble.arrs.push([gyhSingleDouble]);
    }
    if (a['gyh'].smallBig.last === gyhSmallBig) {
      let sblen = a['gyh'].smallBig.arrs.length;
      a['gyh'].smallBig.arrs[sblen - 1].push(gyhSmallBig);
    } else {
      a['gyh'].smallBig.last = gyhSmallBig;
      a['gyh'].smallBig.arrs.push([gyhSmallBig]);
    }

    arr.map((x, i) => {
      if (!a[i]) {
        a[i] = {
          smallBig: { arrs: [], last: '', name: '大小', labels: smallBigLabels },
          singleDouble: { arrs: [], last: '', name: '单双', labels: singleDoubleLabels }
        };
      }

      let isingleDouble = singleDouble(x);
      let ismallBig = x < 5 ? 0 : 1;

      if (a[i].singleDouble.last === isingleDouble) {
        let sdlen = a[i].singleDouble.arrs.length;
        a[i].singleDouble.arrs[sdlen - 1].push(isingleDouble);
      } else {
        a[i].singleDouble.last = isingleDouble;
        a[i].singleDouble.arrs.push([isingleDouble]);
      }

      if (a[i].smallBig.last === ismallBig) {
        let sblen = a[i].smallBig.arrs.length;
        a[i].smallBig.arrs[sblen - 1].push(ismallBig);
      } else {
        a[i].smallBig.last = ismallBig;
        a[i].smallBig.arrs.push([ismallBig]);
      }

      if (i < 5) {
        if (!a[i].dragonTiger) {
          a[i]['dragonTiger'] = { arrs: [], last: '', name: '龙虎', labels: dragonTigerLabels };
        }

        let idragonTiger = dragonTiger(x, arr[9 - i]);
        if (a[i].dragonTiger.last === idragonTiger) {
          let dtlen = a[i].dragonTiger.arrs.length;
          a[i].dragonTiger.arrs[dtlen - 1].push(idragonTiger);
        } else {
          a[i].dragonTiger.last = idragonTiger;
          a[i].dragonTiger.arrs.push([idragonTiger]);
        }
      }
    });
    return a;
  }, {});
};

export default (type, data, ranks, roads) => {
  if (type == 'ssc' || type == 'choose5') {
    return ssc(data, ranks, roads, type);
  }
  if (type == 'PK10' || type == 'nn') {
    return pk10(data, ranks, roads);
  }
};



// WEBPACK FOOTER //
// ./src/helpers/statistic/getRoads.js